import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  profileInfoBar: {
    padding: theme.spacing(1, 0.5)
  }
}));
